export function useQueryParamNumber(key: string, defaultValue = 0) {
  const route = useRoute();
  const query = toRef(route, `query`);

  return computed(() => {
    if (!query.value[key]) return defaultValue;
    const numberParam = Array.isArray(query.value[key]) ? query.value[key][0] : query.value[key];
    if (!numberParam) return defaultValue;
    const parsed = Number.parseInt(numberParam);
    if (Number.isNaN(parsed)) return defaultValue;
    return parsed;
  });
}
